import { CryptoConfig } from '@/config/crypto-config'

const textToChars = (text: string) => Array.from(text).map((c) => c.charCodeAt(0))
const byteHex = (n: number) => ('0' + Number(n).toString(16)).slice(-2)
const applySaltToChar = (salt: string) => (code: number) =>
  textToChars(salt).reduce((a, b) => a ^ b, code)

const cipher = (salt: string) => (text: string) => {
  const encoded = encodeURIComponent(text)
  return Array.from(encoded)
    .map((char) => char.charCodeAt(0))
    .map(applySaltToChar(salt))
    .map(byteHex)
    .join('')
}

const decipher = (salt: string) => (encoded: string) => {
  const matched = encoded.match(/.{1,2}/g)
  if (!matched) return ''

  const decoded = matched
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar(salt))
    .map((charCode) => String.fromCharCode(charCode))
    .join('')

  return decodeURIComponent(decoded)
}

export const crypt = cipher(CryptoConfig.cryptSalt)
export const decrypt = decipher(CryptoConfig.cryptSalt)
